export const VIEW_PAGE_ASSIGN_GRAPHIC_ORGANIZERS_FEATURE =
  "assign_graphic_organizers";
